import {
  APPLICANTS_SET_FILTERS,
  APPLICANTS_CLEAR_FILTERS,
  APPLICANTS_SET_PAGE,
  APPLICANTS_SET_PAGE_SIZE,
  APPLICANTS_SET_SEARCH,
  APPLICANTS_SET_SORT,
  APPLICANTS_FETCH_REQUEST,
  APPLICANTS_FETCH_SUCCESS,
  APPLICANTS_FETCH_FAILURE,
} from '../actions/actionTypes';
import { ApplicantsAction } from '../actions/applicantsActions';
import { FiltersState, EMPTY_FILTERS } from '../../Talent/components/FiltersDrawer';
import { RawTalentRow } from '../../Talent/transformers/talentTransformer';

export interface ApplicantsState {
  filters: FiltersState;
  search: string;
  sort: { column: string; direction: string } | null;
  data: RawTalentRow[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
  loading: boolean;
  error: string | null;
}

const initialState: ApplicantsState = {
  filters: EMPTY_FILTERS,
  search: '',
  sort: null,
  data: [],
  pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 },
  loading: false,
  error: null,
};

export default function applicantsReducer(
  state: ApplicantsState = initialState,
  action: ApplicantsAction,
): ApplicantsState {
  switch (action.type) {
    case APPLICANTS_SET_FILTERS:
      return { ...state, filters: action.payload, pagination: { ...state.pagination, page: 1 } };
    case APPLICANTS_CLEAR_FILTERS:
      return { ...state, filters: EMPTY_FILTERS, pagination: { ...state.pagination, page: 1 } };
    case APPLICANTS_SET_SEARCH:
      return { ...state, search: action.payload, pagination: { ...state.pagination, page: 1 } };
    case APPLICANTS_SET_SORT:
      return { ...state, sort: action.payload, pagination: { ...state.pagination, page: 1 } };
    case APPLICANTS_SET_PAGE:
      return { ...state, pagination: { ...state.pagination, page: action.payload } };
    case APPLICANTS_SET_PAGE_SIZE:
      return { ...state, pagination: { ...state.pagination, pageSize: action.payload, page: 1 } };
    case APPLICANTS_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case APPLICANTS_FETCH_SUCCESS:
      return { ...state, loading: false, data: action.payload.data, pagination: action.payload.pagination };
    case APPLICANTS_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
